import React, { useMemo } from 'react'

import BedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import RoomIcon from 'components/Luxkit/Icons/line/LineDoorIcon'
import { sortBy } from 'lib/array/arrayUtils'
import { Bedbank } from '@luxuryescapes/contract-svc-bedbank'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const allowFeatures = {
  room: <RoomIcon />,
  bed: <BedIcon />,
}

interface Props {
  features: Bedbank.RoomFeature[];
  className?: string;
}

function BedbankRoomFeatures(props: Props) {
  const { features, className } = props

  const filteredFeatures = useMemo(() => {
    const types = new Set(Object.keys(allowFeatures))
    return sortBy(features.filter(feature => types.has(feature.id)), (feature) => feature.id, 'asc')
  }, [features])

  return <VerticalSpacer gap={4} className={className}>
    {filteredFeatures.map(feature => (
      <BodyTextBlock key={feature.id} variant="medium" startIcon={allowFeatures[feature.id]}>
        {feature.text}
      </BodyTextBlock>
    ))}
  </VerticalSpacer>
}

export default React.memo(BedbankRoomFeatures)
